import React from "react";
import { Form, Formik } from "formik";
import FormModalShell from "../ui/form-modal-shell";
import { FormSelectRow } from "./form-select-row";
import {
  CourierActions,
  CourierCheck,
  CourierReadonly
} from "../ui/courier-fields";

const EditCourierForm = ({
  courier,
  zones = [],
  closeModal,
  loading,
  apiError,
  updateCourier
}) => (
  <FormModalShell title="Edit Courier" apiError={apiError} onClose={closeModal}>
    <Formik
      enableReinitialize
      initialValues={{
        zones: (courier.zones || []).map(z => z.id),
        isActive: courier.isActive,
        isOnDuty: courier.isOnDuty
      }}
      onSubmit={values => {
        updateCourier({
          id: courier.id,
          data: {
            zones: values.zones,
            isActive: values.isActive,
            isOnDuty: values.isOnDuty
          }
        });
      }}
    >
      {formik => (
        <Form>
          <CourierReadonly
            label="Courier"
            value={`${courier.fullName || ""} · ${courier.phone || ""}`}
            span
          />
          <FormSelectRow
            label="Primary zone"
            name="zonePick"
            value={formik.values.zones[0] || ""}
            placeholder="Select zone"
            options={zones.map(z => ({ value: z.id, label: z.name }))}
            onChange={e => {
              const id = e.target.value;
              formik.setFieldValue("zones", id ? [Number(id)] : []);
            }}
          />
          <CourierCheck
            label="Active"
            checked={formik.values.isActive}
            onChange={e => formik.setFieldValue("isActive", e.target.checked)}
          />
          <CourierCheck
            label="On duty"
            checked={formik.values.isOnDuty}
            onChange={e => formik.setFieldValue("isOnDuty", e.target.checked)}
          />
          <CourierActions
            loading={loading}
            submitLabel="Save Changes"
            onCancel={closeModal}
          />
        </Form>
      )}
    </Formik>
  </FormModalShell>
);

export default EditCourierForm;
